module.exports = __webpack_public_path__ + "static/media/LinkDownloaderInCard.2d0446e5.svg";